import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { RadioGroupField } from "../../../components/fields/RadioGroupField";

export const ThisOrAllMeetingsModal = (props) => {
  const { isOpen, setIsOpen, onSubmit } = props;

  const form = useForm({
    mode: "onChange",
    defaultValues: {
      updateType: "thisMeeting", // thisMeeting or thisAndFollowingMeetings
    },
  });

  const {
    handleSubmit,
    formState: { isSubmitting, isValid },
  } = form;

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      size={"sm"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Update recurring meeting</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormProvider {...form}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <RadioGroupField
                field={{
                  id: `updateType`,
                  // label: questionLabel,
                  // validation: {
                  //   required: true,
                  // },
                  options: [
                    { label: "This meeting", value: "thisMeeting" },
                    {
                      label: "This and following meetings",
                      value: "thisAndFollowingMeetings",
                    },
                    {
                      label: "All meetings",
                      value: "allMeetings",
                    },
                  ],
                }}
              />
              <Button
                isLoading={isSubmitting}
                isDisabled={!isValid}
                type={"submit"}
                mt={4}
              >
                Save
              </Button>
            </form>
          </FormProvider>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};
